var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgUser = function SvgUser(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99996 10.688C12.2844 10.688 14.1358 8.83653 14.1358 6.55212C14.1358 4.2677 12.2844 2.41626 9.99996 2.41626C7.71554 2.41626 5.8641 4.2677 5.8641 6.55212C5.8641 8.83653 7.71554 10.688 9.99996 10.688ZM12.8951 11.7219H12.3555C11.6381 12.0515 10.8401 12.2389 9.99996 12.2389C9.15986 12.2389 8.365 12.0515 7.64446 11.7219H7.10486C4.70735 11.7219 2.76221 13.6671 2.76221 16.0646V17.4087C2.76221 18.265 3.4569 18.9597 4.31315 18.9597H15.6868C16.543 18.9597 17.2377 18.265 17.2377 17.4087V16.0646C17.2377 13.6671 15.2926 11.7219 12.8951 11.7219Z",
    fill: "white"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgUser, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/user.3d1a997d.svg";
export { ForwardRef as ReactComponent };